// Hamilton College's concentrations (majors) (#2652, round 2). Read on
// 2026-10-01 from Hamilton's official Areas of Study page (hamilton.edu),
// which marks minor-only (*) and language-only (**) areas, and checked one by
// one against the 2026-2027 College Catalogue's Academic Programs pages
// (hamilton.smartcatalogiq.com, the catalogue hamilton.edu/catalogue opens),
// which name each concentration. Where the two differ the catalogue's
// concentration name is used: "Anthropology" is the Cultural Anthropology
// concentration (Archaeology is its own), "Literature and Creative
// Writing" is two concentrations, Literature and Creative Writing, and
// "Mathematics and Statistics" offers the Mathematics concentration
// (Statistics is a minor). Left out: department headings (East Asian
// Languages and Literatures, which holds the Chinese and Japanese
// concentrations; German, Russian, Italian, Arabic), cross-references
// (Greek and Latin: see Classics), and "Spanish", which the catalogue
// offers as the Hispanic Studies concentration. The Interdisciplinary
// Concentration is the catalogue's self-designed option. Degree: the
// catalogue's Conferral of Degrees ("All qualified students receive the
// degree of Bachelor of Arts").
const majors = {
    "slug": "hamilton-college",
    "read": "2026-10-01",
    "intro": "Every concentration (Hamilton's word for a major) on Hamilton's official Areas of Study list, checked against the 2026-2027 College Catalogue. Every graduate earns a Bachelor of Arts. Minors and language-only programs are left out.",
    "groups": [
        {
            "name": "Concentrations",
            "source": {
                "label": "Hamilton, Areas of Study",
                "url": "https://www.hamilton.edu/academics/areas-of-study"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Archaeology",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry/Molecular Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Chemical Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chinese",
                    "degree": "B.A."
                },
                {
                    "name": "Cinema and Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Creative Writing",
                    "degree": "B.A."
                },
                {
                    "name": "Cultural Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Dance and Movement Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Data Science",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geoarchaeology",
                    "degree": "B.A."
                },
                {
                    "name": "Geosciences",
                    "degree": "B.A."
                },
                {
                    "name": "German Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Government",
                    "degree": "B.A."
                },
                {
                    "name": "Hispanic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese",
                    "degree": "B.A."
                },
                {
                    "name": "Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Middle East and Islamicate Worlds Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Public Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Russian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "B.A."
                },
                {
                    "name": "World Politics",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
